module.exports = __webpack_public_path__ + "img/HQ-PS24-V2-V10-T.e976d8f0.jpg";